module.exports = __webpack_public_path__ + "img/党建1.3ebff6ec.jpg";